import React, { Suspense } from "react";
import { motion } from "framer-motion";
import { climates } from "../../constants/capitals";

const CapitalInputRow = ({ element, value, handleListItemClick }) => {
  const nameUpper = element.name.toUpperCase();
  const bgIdx = nameUpper.indexOf(value);

  return (
    <motion.li
      whileHover={{ scale: 0.98 }}
      whileTap={{ scale: 0.95 }}
      onClick={() => handleListItemClick(element)}
    >
      <div className="flex cursor-pointer select-none flex-row items-center justify-start overflow-hidden border-b-2 bg-white hover:bg-majky-400 hover:text-white dark:bg-slate-800 dark:text-slate-100 dark:hover:bg-majky-500">
        <Suspense fallback={null}>
          <img
            className="mx-2 my-0.5 h-7 w-7"
            alt={element.name}
            src={
              element.category !== ""
                ? `/images/city/${element.category}.svg`
                : `/images/city/${climates[element.climate]}.svg`
            }
          />
        </Suspense>
        <span>
          {nameUpper.slice(0, bgIdx)}
          <strong>{value}</strong>
          {nameUpper.slice(bgIdx + value.length)}
        </span>
      </div>
    </motion.li>
  );
};

export default CapitalInputRow;
